import { ENV } from "../utils";

export class Auth {
  baseApi = ENV.BASE_API;

  async register(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTER}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
          policyVersion: data.policyVersion,
        }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async login(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LOGIN}`;
      const params = {
        method: "POST",
        credentials: "include", // necesario para que el servidor pueda setear la cookie httpOnly
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async verifyEmailCode(challengeToken, code, keepSession) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.TWO_FA_VERIFY}`;
      const response = await fetch(url, {
        method: "POST",
        credentials: "include", // necesario para que el servidor pueda setear la cookie httpOnly
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ challengeToken, code, keepSession }),
      });
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async resendEmailCode(challengeToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.TWO_FA_RESEND}`;
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ challengeToken }),
      });
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async refreshAccessToken() {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REFRESH_ACCESS_TOKEN}`;
      const params = {
        method: "POST",
        credentials: "include", // envía la cookie httpOnly al servidor
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // keepSession decide dónde vive el accessToken: localStorage (sobrevive a
  // cerrar el navegador) o sessionStorage (se borra al cerrar la pestaña,
  // igual que la refresh-token cookie de sesión que emite el servidor en
  // ese caso). Se persiste la preferencia para que las renovaciones
  // silenciosas (reLogin) sigan usando el mismo storage sin tener que
  // pasarla de nuevo en cada llamada.
  setAccessToken(token, keepSession) {
    if (keepSession !== undefined) {
      localStorage.setItem(ENV.JWT.KEEP_SESSION, keepSession ? "1" : "0");
    }
    const remember = localStorage.getItem(ENV.JWT.KEEP_SESSION) !== "0";
    const storage = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    storage.setItem(ENV.JWT.ACCESS, token);
    other.removeItem(ENV.JWT.ACCESS);
  }

  getAccessToken() {
    return sessionStorage.getItem(ENV.JWT.ACCESS) || localStorage.getItem(ENV.JWT.ACCESS);
  }

  // refreshToken ahora es httpOnly cookie — estos métodos son no-ops por compatibilidad
  setRefreshToken() {}
  getRefreshToken() { return null; }

  async serverLogout() {
    try {
      const url = `${this.baseApi}/auth/logout`;
      await fetch(url, {
        method: "POST",
        credentials: "include", // envía la cookie para que el servidor la invalide
        headers: { "Content-Type": "application/json" },
      });
    } catch (_) {
      // Ignorar errores de red — el cliente igual limpia sus tokens locales
    }
  }

  removeTokens() {
    localStorage.removeItem(ENV.JWT.ACCESS);
    sessionStorage.removeItem(ENV.JWT.ACCESS);
    localStorage.removeItem(ENV.JWT.REFRESH);
    localStorage.removeItem(ENV.JWT.KEEP_SESSION);
    localStorage.removeItem("site");
    localStorage.removeItem("company");
  }
}
